import { render, staticRenderFns } from "./FIBService.vue?vue&type=template&id=4dd8ddf3&"
import script from "./FIBService.vue?vue&type=script&lang=js&"
export * from "./FIBService.vue?vue&type=script&lang=js&"
import style0 from "./FIBService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QColor});
